'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionReportProblem = function ActionReportProblem(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
  );
};
ActionReportProblem = (0, _pure2.default)(ActionReportProblem);
ActionReportProblem.displayName = 'ActionReportProblem';
ActionReportProblem.muiName = 'SvgIcon';

exports.default = ActionReportProblem;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/report-problem.js
 ** module id = 1558
 ** module chunks = 0
 **/